import { $http } from 'boot/axios'

export class legalsRepository {
  static loadLegals(type) {
    return $http.get('legals/' + type)
  }
}
